import React from "react";

function WhyShouldLaunch() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Why Should You Launch a Security Token Exchange?
              </h2>
              <p>
                Launching a security token exchange presents significant
                benefits for the platform owner, primarily by unlocking new
                revenue streams and positioning them at the forefront of the
                evolving digital finance landscape. By providing a compliant
                platform for trading tokenized securities, owners can tap into
                the growing demand for tokenization, attracting global investors
                and issuers. The platform benefits from transaction fees,
                listing fees for new tokens, and enhanced liquidity by enabling
                fractional ownership of traditional assets like real estate or
                stocks.
              </p>

              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhyShouldLaunch;
